/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/

document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.swatch__button a').forEach(function(el) {
        el.addEventListener('mouseenter', function() {
            el.click();
        });
    });
});